module.exports = __webpack_public_path__ + "img/gabarito-6.d42bb7a0.png";